export default "__VITE_ASSET__CnGWxrN5__"